import { Box, Chip, Typography } from "@mui/material";

export interface CompanyPropsData {
  year?: string;
  project?: string;
  role?: string;
  description?: string;
  type?: string;
  name?: string;
  techTitle?: string;
  technologies?: string[];
}

interface CompanyProps {
  item: CompanyPropsData;
  isLeft: boolean;
}

const Company = ({ item, isLeft }: CompanyProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        position: "relative",
        width: "100%",
        mb: 4,
      }}
    >
      {/* Left Timeline Card */}
      <Box sx={{ width: "calc(60% - 200px)" }}>
        <Typography variant="h6">{item.project}</Typography>
        <Typography variant="caption" color="text.secondary">
          {item.year}
        </Typography>
        <Typography>{item.role}</Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {item.description}
        </Typography>
      </Box>
      {/* Right Timeline Card */}
      <Box sx={{ width: "calc(60% - 200px)" }}>
        {item.technologies?.map((tech, index) => (
          <Chip key={index} label={tech} sx={{ m: 0.5 }} />
        ))}
      </Box>
    </Box>
  );
};

export default Company;
